import React from "react";
import ScrollContainer from 'react-indiana-drag-scroll';
import { useMantineTheme, Group, rem, Text, Box } from '@mantine/core';

import { IconArrowNarrowDown, IconArrowNarrowUp } from '@tabler/icons-react';

import { regexNoStriped } from "../../utils/globalFunctions";

const SortSegmentedControl = ({ stateSortList, stateSortSelected, fnSort, stateStyle = {} }) => {

    const theme = useMantineTheme();

    const SegmentedControlSelector = ({ paramSortInUse, paramSortSelected, functionSort }) => {

        const selectedInUse = regexNoStriped(paramSortInUse.slug) === regexNoStriped(paramSortSelected.slug);

        return (
            <Box
                className='wrapperSegmentedCustomBox'
            >
                <Group
                    noWrap
                    spacing='xs'

                    className={`${selectedInUse ? 'active' : ''} wrapperSegmentedCustom`}
                    sx={() => ({
                        cursor: 'pointer',
                        '& .wrapperSegmentedCustomText:hover': {
                            color: theme.colorScheme === 'light' ? '#000' : '#fff'
                        },
                    })}

                    py={rem(5)}
                    px={rem(10)}

                    onClick={() => {
                        functionSort(paramSortInUse);
                    }}
                >
                    <Text
                        className="wrapperSegmentedCustomText"
                        size='sm'
                        fw={500}
                        c={theme.colorScheme === 'light' ? (selectedInUse ? '#000' : theme.colors.gray[7]) : (selectedInUse ? '#fff' : theme.colors.gray[5])}

                        sx={{
                            whiteSpace: 'nowrap',
                            userSelect: 'none',
                        }}
                    >
                        {paramSortInUse.caption}
                    </Text>

                    {selectedInUse && (paramSortSelected.slug)[0] === '-' &&
                        <IconArrowNarrowUp
                            size={14}
                            color={theme.colorScheme === 'light' ? 'black' : 'white'}
                            style={{ marginRight: '-.25rem' }}
                            stroke={1.5}
                        />
                    }

                    {selectedInUse && (paramSortSelected.slug)[0] !== '-' &&
                        <IconArrowNarrowDown
                            size={14}
                            color={theme.colorScheme === 'light' ? 'black' : 'white'}
                            style={{ marginRight: '-.25rem' }}
                            stroke={1.5}
                        />
                    }
                </Group>
            </Box>
        )
    }

    return (
        typeof stateSortList === 'object' && Object.keys(stateSortList).length > 0 &&
        <ScrollContainer
            className='transparentScrollBarNoWidth'
            vertical={false}
            horizontal={true}
            hideScrollbars={false}

            style={{
                ...{
                    backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[7],
                    borderRadius: rem(4),
                },
                ...stateStyle
            }}
        >
            <Group
                noWrap
                spacing={0}

                sx={() => ({
                    '& .wrapperSegmentedCustom.active': {
                        backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[6],
                        borderRadius: rem(4),
                        boxShadow: theme.shadows.xs
                    },
                    '& .wrapperSegmentedCustom': {
                        marginRight: rem(2)
                    },
                    '& .wrapperSegmentedCustomBox:last-child': {
                        paddingRight: rem(2)
                    },
                })}

                p='.25rem'
            >
                {Object.keys(stateSortList).map(key => {
                    return (
                        <SegmentedControlSelector
                            key={key}
                            paramSortInUse={stateSortList[key]}
                            paramSortSelected={stateSortSelected}
                            functionSort={fnSort}
                        />
                    )
                })}
            </Group>
        </ScrollContainer>
    )
}

export default React.memo(SortSegmentedControl);